import React, { useState } from 'react';
import {
  Modal,
  ModalBody,
  Label,
  Input,
  Col,
  Row,
  Container,
} from 'reactstrap';
import { CommonButton } from '../../Components/CommonComponents';
import closeImg from '../../images/modalclose.png';
import uploadImg from '../../images/upload.png';
import previewImg from '../../images/previewImg.png';
import { UploadDocPreview } from '../../Components/CustomModal';
import ModalService from '../../services/ModalService';
import {
  dealerDocumentUpload,
  savePunchInData,
  savePunchOutData,
} from '../../constants/apiCalls';
import { handleErrorMessage } from '../../utils/utils';
import CustomSpinner from '../../Components/CustomSpinner/CustomSpinner';
import moment from 'moment';

export const PunchInOutModal = ({
  handleIsModal,
  id,
  userId,
  resetId,
  punchOutData,
  modalVariable,
  fetchData,
  isMobile
}) => {
  const [modal, setModal] = useState(true);
  const [inputs, setInputs] = useState({
    name1: '',
    name2: '10:30',
    imgUpload: '',
  });

  const [isModalLoading, setIsModalLoading] = useState(false);

  const [imgUpload, setImgUpload] = useState('');
  const [previewImgModal, setPreviewImgModal] = useState(false);
  const [title, setTitle] = useState('');
  const [popupImgPreview, setPopupImgPreview] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [isPreviewRemove, setIsPreviewRemove] = useState(false);


  const toggle = () => {
    if (modalVariable.title === 'Punch In') handleIsModal('PunchIn');
    else handleIsModal('PunchOut');
    setModal(!modal);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleUploadImg = (e) => {
    const { name, files } = e.target;
    setInputs({ ...inputs, [name]: files[0] });

    let formData = new FormData();

    if (isMobile === 'true') {
      for (let i = 0; i < e.target.files.length; i++) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64Url = event.target.result;
          formData.append('files', base64Url);
          formData.append('isBase64', true);
          formData.append('ownerimage', true);

          setIsModalLoading(true);
          dealerDocumentUpload((res) => {
            const { success, data, error } = res;
            if (success === true) {
              setImgUpload(data.imageUrl);
              setIsModalLoading(false);
            } else if (success === false || success === 'undefined') {
              ModalService.openAlert(
                '',
                handleErrorMessage(error[0].message),
                'error',
              );
              setIsModalLoading(false);
            }
            setIsModalLoading(false);
          }, formData);

        };
        reader.readAsDataURL(e.target.files[i]);
      }
      return
    } else {
      for (let i = 0; i < e.target.files.length; i++) {
        formData.append('files', e.target.files[i]);
      }
    }

    formData.append('ownerimage', true);

    setIsModalLoading(true);
    dealerDocumentUpload((res) => {
      const { success, data, error } = res;
      if (success === true) {
        setImgUpload(data.imageUrl);
        setIsModalLoading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsModalLoading(false);
      }
      setIsModalLoading(false);
    }, formData);
  };

  const togglePreviewImgModal = (val) => {
    setPopupImgPreview(val);
    setTitle('Speedometer Image');
    setPreviewImgModal(!previewImgModal);
  };

  const removeSelectedImage = () => {
    setImgUpload();
    setImagePreview();
    setPreviewImgModal(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const [hourString, minute] = inputs.name2.split(':');
    const hour = +hourString % 24;

    if (Number(inputs.name1) < 0) {
      ModalService.openAlert(
        '',
        handleErrorMessage('Please enter a positive value for distance'),
        'error',
      );
      return;
    }

    if (modalVariable.title === 'Punch In') {
      setIsModalLoading(true);
      savePunchInData(
        (res) => {
          const { success, error } = res;

          if (success) {
            setIsModalLoading(false);

            fetchData();
            toggle();
            resetId();
          } else if (success === false || success === 'undefined') {
            setIsModalLoading(false);

            ModalService.openAlert(
              '',
              handleErrorMessage(error[0].message),
              'error',
            );
          }
          setIsModalLoading(false);
        },
        {
          start_km: inputs.name1,
          in_time: moment()
            .hour(hour)
            .minute(minute)
            .second(0)
            .toISOString(),
          speedometer_image_in: imgUpload,
        },
      );
    }
    if (modalVariable.title === 'Punch Out') {
      if (
        moment()
          .hour(hour)
          .minute(minute)
          .second(0)
          .isBefore(moment(punchOutData.time)) ||
        punchOutData.start >= Number(inputs.name1)
      ) {
        ModalService.openAlert(
          '',
          'End KM and Out time should be greater than In KM and In Time',
          'error',
        );
        return;
      }

      setIsModalLoading(true);
      savePunchOutData(
        (res) => {
          const { success, error } = res;

          if (success) {
            setIsModalLoading(false);

            fetchData();
            toggle();
            resetId();
          } else if (success === false || success === 'undefined') {
            setIsModalLoading(false);

            ModalService.openAlert(
              '',
              handleErrorMessage(error[0].message),
              'error',
            );
          }
        },
        {
          end_km: inputs.name1,
          out_time: moment()
            .hour(hour)
            .minute(minute)
            .second(0)
            .toISOString(),
          speedometer_image_out: imgUpload,
          user_id: userId,
          punchin_id: id,
        },
      );
    }
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered id="punch-in-out">
      {isModalLoading && <CustomSpinner />}
      <ModalBody>
        <Container fluid>
          <Row>
            <Col xs={12} className="modalHeading">
              <div className="title">{modalVariable.title}</div>
              <div className="closeButton">
                <img src={closeImg} alt="close" onClick={toggle} />
              </div>
            </Col>
            <Col xs={12}>
              <form onSubmit={handleSubmit}>
                <Label for="label1">
                  {modalVariable.label[0]}
                  <span className="required">*</span>
                </Label>
                <Input
                  name="name1"
                  placeholder="Type Here"
                  type="number"
                  min={0}
                  value={inputs.name1}
                  onChange={handleChange}
                  required
                />

                <div>
                  <Label
                    for="label3"
                    className="common-input-label mb-3 mt-2 mr-3"
                  >
                    Speedometer Image<span className="required">*</span>
                  </Label>
                  {!(imgUpload || imagePreview) ? (
                    <Label className="uploadLabel">
                      <Input
                        type="file"
                        name="imgUpload"
                        onChange={(e) => handleUploadImg(e)}
                        accept="image/*"
                        required={!(imgUpload || imagePreview)}
                      />
                      <img
                        className="uploadImg"
                        src={uploadImg}
                        alt="uploadImg"
                      />
                    </Label>
                  ) : (
                    <img
                      src={previewImg}
                      alt="previewImg"
                      className="preViewImg"
                      onClick={() => {
                        setIsPreviewRemove(true);
                        togglePreviewImgModal(imgUpload || imagePreview);
                      }}
                    />
                  )}
                </div>

                <Label for="label2">
                  {modalVariable.label[1]}
                  <span className="required">*</span>
                </Label>
                <Input
                  name="name2"
                  placeholder="select"
                  type="time"
                  value={inputs.name2}
                  onChange={handleChange}
                  required
                />
                <Row className="punchInOut-btn">
                  <Col xs={6}>
                    <CommonButton
                      name="Cancel"
                      type="button"
                      btnClass="btn btn-outline-primary"
                      onClick={toggle}
                    />
                  </Col>
                  <Col xs={6}>
                    <CommonButton
                      name={modalVariable.title}
                      btnClass={'btnPrimary'}
                      type="submit"
                    />
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Container>

        {/* Preview Doc Modal */}
        <Modal
          id="previewOwnerImgModal"
          isOpen={previewImgModal}
          toggle={togglePreviewImgModal}
          className="uploadDocModal"
          centered
        >
          <ModalBody className="pl-0 pr-0">
            <Container>
              <Row>
                <Col xs={12}>
                  <div className="modalHeading">
                    <div className="title leftTitle">{title}</div>
                    <div className="closeButton">
                      <img
                        src={closeImg}
                        alt="closeImg"
                        onClick={() => setPreviewImgModal(!previewImgModal)}
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} className="text-center">
                  <UploadDocPreview
                    isRemove={isPreviewRemove}
                    uploadDocpath={popupImgPreview}
                    handleRemoveClick={removeSelectedImage}
                  />
                </Col>
              </Row>
            </Container>
          </ModalBody>
        </Modal>
      </ModalBody>
    </Modal>
  );
};
